// Returns true if conditions passed for job
export const checkCondition = (x, job_data, internal) => {
    for (var key of Object.keys(x.Conditions)) {
        // check if job data passes the condition through index OR is a special conditional case
        if (!checkSpecialConditions(key, x.Conditions[key], job_data, internal)) {
            return false;
        }
    }

    // All conditions passed return true
    return true;
};

// If there are special conditions pass through
const checkSpecialConditions = (key, condition, job_data, internal) => {
    // Check if any items exist in list
    if (key === "AnyItem") {
        if (job_data?.QuoteParameters?.BOM?.OrderList?.items) {
            for (var keys of Object.keys(job_data?.QuoteParameters?.BOM?.OrderList?.items)) {
                if (allConditionTypes(job_data?.QuoteParameters?.BOM?.OrderList?.items[keys].Code, condition)) {
                    return true;
                }
            }
        } else if (job_data?.QuoteParameters?.BOM?.SystemList?.items)
            for (var keys of Object.keys(job_data?.QuoteParameters?.BOM?.SystemList?.items)) {
                if (allConditionTypes(job_data?.QuoteParameters?.BOM?.SystemList?.items[keys].Code, condition)) {
                    return true;
                }
            }
    }

    // Internal drawing, check if user has access based on role
    if (key === "Internal") {
        if (internal) {
            if (parseInt(internal) >= parseInt(condition)) {
                return true;
            }
        }
    }

    // Check all OR conditions from key aswell (NOTE: Only set up with OR conditions)
    if (key.includes("|")) {
        // check all conditions from key split by |
        let passed = [];
        for (var k of key.split("|")) {
            passed.push(keyConditions(k, job_data, condition));
        }
        if (passed.includes(true)) {
            return true;
        }
        return false;
    } else {
        return keyConditions(key, job_data, condition);
    }
};

const checkAttachments = (key, job_data, condition) => {
    let attachments = [];
    for (let index in job_data?.AreaSpecifications) {
        let areaIndex = Number(index);
        let current_area = job_data?.AreaSpecifications[areaIndex];
        let totalAttachments =
            current_area["ATTACHMENTS"]["AttachmentBottom"] +
            current_area["ATTACHMENTS"]["AttachmentLeft"] +
            current_area["ATTACHMENTS"]["AttachmentRight"] +
            current_area["ATTACHMENTS"]["AttachmentTop"];

        for (let mods in current_area["ATTACHMENTS"]["AttachmentModifications"]) {
            attachments.push({
                attachment:
                    current_area["ATTACHMENTS"]["AttachmentModifications"][mods]["AttachmentType"] ===
                    ("" || null || undefined)
                        ? job_data?.QuoteParameters?.BOM?.QuoteData?.JOB_DATA[key.split(".")[1]]
                        : current_area["ATTACHMENTS"]["AttachmentModifications"][mods]["AttachmentType"],
                subAttachment:
                    current_area["ATTACHMENTS"]["AttachmentModifications"][mods]["AttachmentVariation"] ===
                    ("" || null || undefined)
                        ? current_area["ATTACHMENTS"]["AttachmentModifications"][mods]["AttachmentSubType"]
                        : current_area["ATTACHMENTS"]["AttachmentModifications"][mods]["AttachmentVariation"],
            });
        }

        // if there are more attachments than modded attachments, there is a default attachment in the area index.
        if (totalAttachments > attachments.length) {
            // add the default attachment
            attachments.push({ attachment: job_data?.QuoteParameters?.BOM?.QuoteData?.JOB_DATA[key.split(".")[1]] });
        }
    }

    for (let attachment in attachments) {
        if (attachments[attachment]?.subAttachment && condition.split("/").length > 1) {
            // Both attachment and subAttachment need to be true
            if (
                allConditionTypes(attachments[attachment]?.attachment, condition.split("/")[0]) &&
                allConditionTypes(attachments[attachment]?.subAttachment, condition.split("/")[1])
            ) {
                return true;
            }
        } else if (allConditionTypes(attachments[attachment]?.attachment, condition.split("/")[0])) {
            return true;
        }
    }

    return false;
};

// Switch case key conditions
const keyConditions = (key, job_data, condition) => {
    let passed = false;
    switch (key.split(".")[0]) {
        case "Area":
        case "AnyArea":
            for (let index in job_data?.QuoteParameters?.BOM?.QuoteData?.AreaSpecifications) {
                if (
                    allConditionTypes(
                        job_data?.QuoteParameters?.BOM?.QuoteData?.AreaSpecifications[index][key.split(".")[1]],
                        condition
                    )
                ) {
                    passed = true;
                    break;
                }
            }
            break;
        case "Job":
            // Special Case for Attachments - check modifications
            if (key.split(".")[1] === "AttachmentType") {
                passed = checkAttachments(key, job_data, condition);
            } else if (
                allConditionTypes(job_data?.QuoteParameters?.BOM?.QuoteData?.JOB_DATA[key.split(".")[1]], condition)
            )
                passed = true;
            break;
        case "Item":
            if (job_data?.QuoteParameters?.BOM?.OrderList?.items) {
                for (var keys of Object.keys(job_data?.QuoteParameters?.BOM?.OrderList?.items)) {
                    if (allConditionTypes(job_data?.QuoteParameters?.BOM?.OrderList?.items[keys].Code, condition)) {
                        passed = true;
                    }
                }
            } else if (job_data?.QuoteParameters?.BOM?.SystemList?.items)
                for (var keys of Object.keys(job_data?.QuoteParameters?.BOM?.SystemList?.items)) {
                    if (allConditionTypes(job_data?.QuoteParameters?.BOM?.SystemList?.items[keys].Code, condition)) {
                        passed = true;
                    }
                }
            break;
        default:
            for (let index in job_data?.QuoteParameters?.BOM?.QuoteData?.AreaSpecifications) {
                if (
                    allConditionTypes(
                        job_data?.QuoteParameters?.BOM?.QuoteData?.AreaSpecifications[index][key],
                        condition
                    )
                ) {
                    passed = true;
                    break;
                }
            }
            break;
    }

    return passed;
};

const allConditionTypes = (check, conditions) => {
    if (check === undefined) {
        if (conditions === false || (typeof conditions === "string" && conditions.startsWith("!"))) {
            return true;
        } else {
            return false;
        }
    }

    if (conditions === true) return true;
    if (conditions === false) return false;
    if (typeof conditions !== "string") return false;

    if (conditions.includes("|")) {
        return conditions.split("|").some((val) => {
            if (val.includes("INCLUDES")) {
                return checkIncludes(val, check);
            } else {
                return allConditionTypes(check, val);
            }
        });
    }

    if (conditions.startsWith("!")) {
        const negatedValue = conditions.substring(1);
        if (negatedValue === "null") {
            return check !== "";
        } else {
            return check !== negatedValue;
        }
    }

    if (conditions.includes("INCLUDES")) {
        return checkIncludes(conditions, check);
    }

    return check === conditions;
};

const checkIncludes = (val, check) => {
    if (check)
        if (check.includes(val.split("INCLUDES(")[1].split(")")[0])) {
            return true;
        }
    return false;
};

// Gets the valid drawings for job based on conditions
const getDrawings = (job_data, config, internal, specificConditions = null) => {
    let drawings = [];

    if (specificConditions) {
        // Only return drawings matching specified conditions
        return (drawings = checkSpecificCondition(config, specificConditions));
    }

    // For all drawings
    if (config?.drawings)
        for (var x of Object.keys(config?.drawings)) {
            if (config?.drawings[x]?.File) {
                // If there is no condition append files
                if (config?.drawings[x]?.Conditions === (null || undefined)) {
                    if (config?.drawings[x]?.File.split("|").length > 0) {
                        for (var drawing of config?.drawings[x]?.File.split("|")) {
                            drawings.push(drawing);
                        }
                    } else drawings.push(config?.drawings[x]?.File);
                } else {
                    // Check the condition and if true append the files
                    if (checkCondition(config?.drawings[x], job_data, internal)) {
                        if (config?.drawings[x]?.File.split("|").length > 0) {
                            for (var drawing_ of config?.drawings[x]?.File.split("|")) {
                                drawings.push(drawing_);
                            }
                        } else drawings.push(config?.drawings[x]?.File);
                    }
                }
            }
        }

    return drawings;
};

// Gets the valid drawings for job based on conditions
const getDrawingsNames = (job_data, config, internal) => {
    let drawings = {};
    // For all drawings
    if (config?.drawings)
        for (var x of Object.keys(config?.drawings)) {
            if (config?.drawings[x]?.File) {
                // If there is no condition append files
                if (config?.drawings[x]?.Conditions === (null || undefined)) {
                    if (config?.drawings[x]?.File.split("|").length > 0) {
                        let addDrawings = [];
                        if (config?.drawings[x]?.Name.split("|").length > 0) {
                            for (var drawing of config?.drawings[x]?.File.split("|")) {
                                addDrawings.push(drawing);
                            }

                            drawings[config?.drawings[x]?.Name] = addDrawings;
                        } else drawings[config?.drawings[x]?.Name] = [config?.drawings[x]?.File];
                    } else drawings[config?.drawings[x]?.Name] = [config?.drawings[x]?.File];
                } else {
                    // Check the condition and if true append the files
                    if (checkCondition(config?.drawings[x], job_data, internal)) {
                        if (config?.drawings[x]?.File.split("|").length > 0) {
                            if (config?.drawings[x]?.Name.split("|").length > 0) {
                                let addDrawings = [];
                                for (var drawing_ of config?.drawings[x]?.File.split("|")) {
                                    addDrawings.push(drawing_);
                                }

                                drawings[config?.drawings[x]?.Name] = drawing_;
                            } else drawings[config?.drawings[x]?.Name] = [config?.drawings[x]?.File];
                        } else drawings[config?.drawings[x]?.Name] = [config?.drawings[x]?.File];
                    }
                }
            }
        }

    return drawings;
};

// Target specific condition/s. E.g. Only return drawings with condition Area.DesignType = "Flat Roof"
const checkSpecificCondition = (config, searchCondition) => {
    const drawings = [];

    for (let drawing of config?.drawings || []) {
        let conditions = drawing?.Conditions || {};

        let isMatch = Object.keys(searchCondition).every((key) => {
            return conditions[key] === searchCondition[key];
        });

        if (isMatch) {
            drawings.push(drawing?.File);
        }
    }

    return drawings;
};

// Drawings main
const Drawings = (job_data, config, setName, internal, specificConditions = null) => {
    let drawingsArray = [];
    // If job data and config, update drawings array
    if (job_data && config && setName) {
        return getDrawingsNames(job_data, config, internal);
    } else if (job_data && config) {
        drawingsArray = getDrawings(job_data, config, internal, specificConditions);
    }

    return drawingsArray;
};

export default Drawings;
